export default "__VITE_ASSET__8v5OEh6R__"